module.exports = __webpack_public_path__ + "img/git.976d22c6.png";